<template>
  <div class="jr-card">
    <h2 class="title-text" v-if="title">
      {{title}}
      <template v-if="status">
        <icon-status
          :color="color"
          :status="status"
        />
      </template>
    </h2>
    <slot name="title" />
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    // 文字
    status: {
      type: String,
      default: '',
    },
    // 颜色
    color: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.jr-card {
  margin-bottom: 43px;

  h2 {
    margin: 0px;
    margin-bottom: 16px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #272728;
  }

  .title-text {
    position: relative;
    padding-left: 10px;

    &:before {
      content: '';
      display: block;
      position: absolute;
      width: 4px;
      height: 8px;
      top: calc((100% - 8px) / 2);
      left: 0;
      background-color: $color-primary;
      border-radius: 1px;
    }
  }
}
</style>

